<template>
    <div class="gray-background">
        <div class="form-title">
            <div class="title-wrapper">
                <b-icon-files></b-icon-files>
                <span>{{ formTitle }}</span>
            </div>
            <b-button v-if="btn" class="add-btn" @click="$emit('openModal')"> <b-icon-plus></b-icon-plus>{{ btn }}</b-button>
        </div>
        <div class="form">
            <b-form-group :label="labelName">
                <b-form-input v-if="inputType !== 'textarea'" id="form-tooltip" v-model="textToCopy" :readonly="readonly" @click="copyText(textToCopy)"></b-form-input>
                <b-form-textarea v-else id="form-tooltip" v-model="textToCopy" :readonly="readonly" @click="copyText(textToCopy)"></b-form-textarea>
                <b-tooltip target="form-tooltip" triggers="hover" placement="bottom">
                    Click pentru a copia textul
                </b-tooltip>
            </b-form-group>
        </div>
    </div>
</template>

<script>
    import { BFormInput, BFormGroup, BFormTextarea, BTooltip, BButton, BIconFiles, BIconPlus } from "bootstrap-vue";
    export default {
        components: {
            BFormGroup,
            BFormInput,
            BFormTextarea,
            BTooltip,
            BButton,
            BIconPlus,
            BIconFiles
        },
        props: {
            labelName: {
                type:String,
                default:""
            },
            inputType: {
                type:String,
                default:""
            },
            textToCopy: {
                type:String,
                default:""
            },
            formTitle: {
                type:String,
                default:""
            },
            readonly: {
                type:Boolean,
                default: true
            },
            btn:{
                type:String,
                default:""
            }
        },
        data() {
            return {
            }
        },
        mounted() {
        },
        created() {
        },
        methods: {
            toggleOpen() {
                this.openedSelect = this.openedSelect !== true;
            },
            onHide(evt) {
                if(evt.trigger === "backdrop"){
                    evt.preventDefault();
                    this.$emit('hideDepPopup')
                }
            },
        }
    }
</script>

<style scoped>
.gray-background{
    background: #fbfbfb;
}
.form{
    padding: 15px;
}
.form-group >>> legend{
    font-size: 14px;
    font-weight: 600;
}
input, textarea{
    font-size: 12px;
    border-radius: 0;
    background-color: transparent !important;
    cursor: pointer;
}
.form-title{
    color: #fff;
    background: linear-gradient(270deg, rgba(52,130,231,1) 20%, rgba(42,104,185,1) 100%);
    font-weight: 600;
    font-size: 17px;
    padding: 1.5rem;
    display: flex;
    align-items: center;
    min-height: 50px;
    justify-content: space-between;
    font-size: 2rem;
}
.form-title .title-wrapper svg {
    margin-right: 10px;
}

.add-btn {
    background-color:#ffffff;
    border-radius:50px;
    border-color:#ffffff;
    color:#000000;
    font-size: .775rem;
    padding: 9px 20px;
    display: flex;
    align-items: center;
}
.add-btn .bi-plus {
    font-size: 200%;
    font-weight: bold;
}
</style>